/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistogramDTO } from './HistogramDTO';
import {
    HistogramDTOFromJSON,
    HistogramDTOFromJSONTyped,
    HistogramDTOToJSON,
} from './HistogramDTO';
import type { FileRefDTO } from './FileRefDTO';
import {
    FileRefDTOFromJSON,
    FileRefDTOFromJSONTyped,
    FileRefDTOToJSON,
} from './FileRefDTO';

/**
 * 
 * @export
 * @interface SeriesValueObjectDTO
 */
export interface SeriesValueObjectDTO {
    /**
     * 
     * @type {FileRefDTO}
     * @memberof SeriesValueObjectDTO
     */
    fileRef?: FileRefDTO;
    /**
     * 
     * @type {HistogramDTO}
     * @memberof SeriesValueObjectDTO
     */
    histogram?: HistogramDTO;
    /**
     * 
     * @type {string}
     * @memberof SeriesValueObjectDTO
     */
    stringValue?: string;
}

/**
 * Check if a given object implements the SeriesValueObjectDTO interface.
 */
export function instanceOfSeriesValueObjectDTO(value: object): value is SeriesValueObjectDTO {
    return true;
}

export function SeriesValueObjectDTOFromJSON(json: any): SeriesValueObjectDTO {
    return SeriesValueObjectDTOFromJSONTyped(json, false);
}

export function SeriesValueObjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValueObjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'fileRef': json['fileRef'] == null ? undefined : FileRefDTOFromJSON(json['fileRef']),
        'histogram': json['histogram'] == null ? undefined : HistogramDTOFromJSON(json['histogram']),
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
    };
}

export function SeriesValueObjectDTOToJSON(value?: SeriesValueObjectDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileRef': FileRefDTOToJSON(value['fileRef']),
        'histogram': HistogramDTOToJSON(value['histogram']),
        'stringValue': value['stringValue'],
    };
}

